module.exports = __webpack_public_path__ + "img/Wasserrettungszug.bc57dfe7.svg";